export const CONSENT_CATEGORIES = [
  { dbKey: 'advertising', cookieKey: 'dg-category-marketing' },
  { dbKey: 'analytics', cookieKey: 'dg-category-performance' },
  { dbKey: 'functional', cookieKey: 'dg-category-functional' },
];

export const preferencesToCookieOptions = pref => ({
  isCustomised: true,
  cookieOptions: [
    { 'gtm_key': 'dg-category-essential', isEnabled: true },
    ...CONSENT_CATEGORIES.map(({ dbKey, cookieKey }) => ({
      'gtm_key': cookieKey,
      isEnabled: pref[dbKey],
    })),
  ],
});

export const parseDataGrailCookie = () => {
  const cookieEntry = document.cookie
    .split('; ')
    .find(row => row.startsWith('datagrail_consent_preferences='));
  if (!cookieEntry) return null;

  return Object.fromEntries(
    cookieEntry
      .slice('datagrail_consent_preferences='.length)
      .split('|')
      .map(pair => {
        const [key, value] = pair.split(':');
        return [key, value === '1'];
      })
  );
};

export const shouldShowBanner = isFastboot => {
  if (!isFastboot) {
    return !document.cookie.includes('datagrail_consent_preferences');
  }
  return true;
};

export const analyticsEnabled = async preferences => {
  return !!preferences.consentPreferences.cookieOptions.find(
    option => option.gtm_key === 'dg-category-analytics'
  )?.isEnabled;
};
